import { useState, useEffect } from 'react';

const useAuthState = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    // Check localStorage on initial load
    useEffect(() => {
        const storedAuthState = localStorage.getItem('isLoggedIn');
        const demoMode = localStorage.getItem('isDemoMode');
        setIsAuthenticated(storedAuthState === 'true' || demoMode === 'true');
    }, []);

    // Listen for changes in localStorage (from other tabs/windows)
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'isLoggedIn' || e.key === 'isDemoMode') {
                const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
                const demoMode = localStorage.getItem('isDemoMode') === 'true';
                setIsAuthenticated(loggedIn || demoMode);
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    return { isAuthenticated, isLoading: isAuthenticated === null };
};

export default useAuthState;